"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var http_1 = require("@angular/common/http");
var upload_file_component_1 = require("../upload-file/upload-file.component");
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var UploadFileQueueComponent = /** @class */ (function () {
    function UploadFileQueueComponent() {
        this.files = [];
        this.httpRequestHeaders = new http_1.HttpHeaders().set("Content-Type", "multipart/form-data");
        this.httpRequestParams = new http_1.HttpParams();
        this.fileAlias = "file";
        this.addFileEvent = new core_1.EventEmitter();
    }
    Object.defineProperty(UploadFileQueueComponent.prototype, "fileUploadRemoveEvents", {
        /** Combined stream of all of the file upload remove change events. */
        get: function () {
            return rxjs_1.merge.apply(void 0, this.fileUploads.map(function (fileUpload) { return fileUpload.removeEvent; }));
        },
        enumerable: true,
        configurable: true
    });
    UploadFileQueueComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        // When the list changes, re-subscribe
        this._changeSubscription = this.fileUploads.changes.pipe(operators_1.startWith(null)).subscribe(function () {
            if (_this._fileRemoveSubscription) {
                _this._fileRemoveSubscription.unsubscribe();
            }
            _this._listenTofileRemoved();
        });
    };
    UploadFileQueueComponent.prototype._listenTofileRemoved = function () {
        var _this = this;
        this._fileRemoveSubscription = this.fileUploadRemoveEvents.subscribe(function (event) {
            _this.files.splice(event.id, 1);
        });
    };
    UploadFileQueueComponent.prototype.addFile = function (file) {
        this.files.push(file);
        this.addFileEvent.emit(file);
    };
    UploadFileQueueComponent.prototype.uploadAll = function () {
        this.fileUploads.forEach(function (fileUpload) {
            fileUpload.upload();
        });
    };
    UploadFileQueueComponent.prototype.removeAll = function () {
        this.files.splice(0, this.files.length);
    };
    UploadFileQueueComponent.prototype.remove = function (file) {
        this.files = this.files.filter(function (x) {
            return x.size != file.size && x.name != file.name && file.lastModified != x.lastModified;
        });
    };
    UploadFileQueueComponent.prototype.ngOnDestroy = function () {
        if (this.files) {
            this.removeAll();
        }
    };
    return UploadFileQueueComponent;
}());
exports.UploadFileQueueComponent = UploadFileQueueComponent;
